import {getPlayerById} from './common'

export const transformPlayersFromServer = (currentPlayers, newPlayers) => {
  let i = 0;
  for (i; i < currentPlayers.length; ++i) {
    const appropriatePlayer = getPlayerById(newPlayers, currentPlayers[i].id).results;
    currentPlayers[i].win = parseInt(appropriatePlayer.win) + '%';
    if (appropriatePlayer.winLo) {
      currentPlayers[i].winLo = parseInt(appropriatePlayer.winLo) + '%';
    } else {
      currentPlayers[i].tie = parseInt(appropriatePlayer.tie) + '%';
    }
  }

  return currentPlayers;
};